// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__2HIlj","banner-msg":"banner_banner-msg__1wYA2"};